export default "__VITE_ASSET__DfOjT6DS__"